import { Stack, styled } from '@mui/material';
import { STYLED_MENU_LIST_WIDTH } from '@/components/common/StyledMenuItems';

export const StyledStatisticsTabWrapper = styled(Stack)(() => ({
  width: `calc(100% - ${STYLED_MENU_LIST_WIDTH})`,
}));
